module.exports = __webpack_public_path__ + "static/media/12-click.0e0e5517.png";